import type {PortableTextObject, PortableTextSpan} from '@portabletext/schema'
import type {EditorSelector} from '../editor/editor-selector'
import type {ChildPath} from '../types/paths'
import {getChildKeyFromSelectionPoint} from '../utils/util.selection-point'
import {getAnchorTextBlock} from './selector.get-anchor-text-block'

/**
 * @public
 */
export const getAnchorChild: EditorSelector<
  | {
      node: PortableTextObject | PortableTextSpan
      path: ChildPath
    }
  | undefined
> = (snapshot) => {
  if (!snapshot.context.selection) {
    return undefined
  }

  const anchorBlock = getAnchorTextBlock(snapshot)

  if (!anchorBlock) {
    return undefined
  }

  const key = getChildKeyFromSelectionPoint(snapshot.context.selection.anchor)

  const node = key
    ? anchorBlock.node.children.find((span) => span._key === key)
    : undefined

  return node && key
    ? {node, path: [...anchorBlock.path, 'children', {_key: key}]}
    : undefined
}
